"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = function _default(items) {
  return items.map(function (_ref) {
    var skuId = _ref.id,
      skuCode = _ref.sku,
      _ref$product = _ref.product,
      _ref$product$name = _ref$product.name,
      name = _ref$product$name === void 0 ? null : _ref$product$name,
      id = _ref$product.id,
      category = _ref$product.category,
      subCategory = _ref$product.subCategory,
      listPrice = _ref$product.listPrice,
      stockLevel = _ref$product.stockLevel,
      colour = _ref$product.colour,
      brands = _ref$product.brands,
      division = _ref$product.division,
      isMarkedDown = _ref$product.isMarkedDown,
      quantity = _ref.quantity,
      size = _ref.size;
    return _objectSpread(_objectSpread(_objectSpread({}, name && {
      name: name
    }), {}, {
      skuId: skuId,
      skuCode: skuCode,
      id: id,
      division: division,
      category: category,
      subcategory: subCategory,
      price: listPrice,
      isMarkedDown: isMarkedDown,
      quantity: quantity,
      stock: stockLevel.toString(),
      colour: colour,
      size: size
    }, brands && {
      brands: brands
    }), {}, {
      variantId: skuId.split(',')[1] || null
    });
  });
};